import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import { BodyText } from '../../../ui';
import { BasicStarIcon } from '../../../ui/Icons';

const TopServiceRatingBannerABTestCOM1252 = ({ serviceRanking, serviceID }) => (
  <Inline
    color={BrandColor.LightGreen}
    borderRadius={24}
    space={4}
    paddingX={8}
    paddingY={4}
    justifyContent="center"
    alignItems="center"
    key={`${serviceID}_ranking_banner`}
    testID={`${serviceID}-top_service_com1252_test`}
  >
    <Box>
      <BasicStarIcon
        width={12}
        height={12}
        color={BrandColor.DarkBlue}
      />
    </Box>
    <BodyText
      appearance="medium"
    >
      #{serviceRanking} Most booked
    </BodyText>
  </Inline>
);

export default TopServiceRatingBannerABTestCOM1252;
